<template>
    <div>
        <div class="headline">
            <h3>{{ 'Cities in ' + this.location.name}}</h3>
            <search
                :placeholder= "'Search for Cities in ' + this.location.name"
                icon="location-city"
                min_len = '3'
                v-on:searchstr="searchForCities($event)">

            </search>

        </div>
        <div class="content">
            <p class="search-info" v-text="searchInfo"></p>
            <ul class="dashboard-box-list">
                <li v-for="(city, i) in visibleCities" :key="i">
                    <div class="job-listing">
                        <div class="job-listing-details">

                            <!-- Logo -->
                            <a href="#" class="job-listing-company-logo">
                                <i class="icon-material-outline-location-city"></i>
                            </a>

                            <!-- Details -->
                            <div class="job-listing-description">
                                <h3 class="job-listing-title">
                                    <span class="country-name" v-text="city.name"></span>
                                </h3>

                                <div class="job-listing-footer">
                                    <ul>
                                        <li><router-link :to="'/admin/location/users?city=' + city.id">View Users</router-link></li>
                                        <li><router-link :to="'/admin/location/projects?city=' + city.id">View Projects</router-link></li>
                                    </ul>


                                </div>
                            </div>
                        </div>
                    </div>
                </li>

            </ul>
            <loader v-if="citiesLoaded  === 0"></loader>
            <br/><br/><br/>

        </div>
    </div>

</template>
<script>
    import {getCities} from '../../../../core/services/location-services'
    import Search from "../../../partials/Search"
    import Loader from "../../../partials/Loader";

    export default {
        name: 'cities',
        props: ['region'],
        components: {Loader, Search},
        data() {
            return {
                users : [],
                cities : [],
                visibleCities : [],
                citiesLoaded : 0,
                finishedLoading: 0, //notifies when ALL CITIES have been loaded from database
                searchTerm: '',
                location: '',
                currentLocation: '',
                searchInfo: '',
            }
        },

        computed: {
        },

        methods : {
            searchForCities(str) {
                this.searchInfo = '';
                this.visibleCities = [];
                if(str.length === 0) {
                    this.visibleCities = this.cities;
                } else {
                    let matchedCities = [];
                    this.cities.forEach((city) => {
                        if((city.name.toLowerCase().search(str.toLowerCase())) !== -1) {
                            matchedCities.push(city);
                        }
                    });

                    this.visibleCities =  matchedCities;
                }
            },

            b4Load() {
                this.searchInfo = '';
                this.currentPage++;
                this.finishedLoading = 1;
                this.citiesLoaded = 0;
            },

            loadCities() {
                this.b4Load();
                getCities(
                    this.region.id
                )
                    .then((response) => {
                        this.visibleCities = response.data.data;
                        this.cities = response.data.data;

                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.citiesLoaded = 1;
                    });

            }

        },

        created() {
            this.location = this.region;
            this.loadCities();

        }
    }
</script>

<style scoped>
    .user-info {
        font-size: 1rem;
        color: #0fbaf1 !important;
    }
    .country-name {
        text-transform: capitalize;
        color: black;
    }
    .country-name::after {
        content: " ";
    }
    .search-info {
        margin: 0 auto;
        text-align: center;
        color: #0fbaf1 !important;
    }
    .user-active-status {
        font-size: 1rem;
        color: green;
    }
    .user-non-active-status {
        font-size: 1rem;
        color: gray;
    }
    .content {
    }
    button {
        line-height: 0.5rem !important;
    }
</style>
